// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rzvX","col":"styles_col__2oUdC"};